module.exports = __webpack_public_path__ + "static/slippers_of_spider_climbing-00b0e9b2e35d1cae13b8a5f07cce1db0.jpeg";